import { alpha, Box, Stack } from "@mui/material";
import MainGrid from "../../components/MainGrid";
import MainLayout from "../../components/MainLayout";

export default function Dashboard() {
  return (
    <MainLayout>
      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          backgroundColor: theme.vars
            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
            : alpha(theme.palette.background.default, 1),
          overflow: "auto",
        })}
      >
        <Stack
          spacing={2}
          sx={{
            alignItems: "center",
            mx: 3,
            pb: 5,
            mt: { xs: 8, md: 0 },
          }}
        >
          <MainGrid />
        </Stack>
      </Box>
    </MainLayout>
  );
}
